import { Card, CardBody, CardHeader } from "../../../components/card/card";
import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import { toast } from "react-toastify";

import ConfirmationDlg from "../../../components/ConfirmationDlg";
import ModalChangeProvince from "./modal/changeProvince";
import { province } from "../../../api";
import { PermissionChecker } from "../../../components/PermissionChecker";

function ProvinceConfiguration() {
  const [openDetail, setOpenDetail] = useState(false);
  const [confirmDlg, setConfirmDlg] = useState(false);
  const [loading, setLoading] = useState(true);
  const [query, setQuery] = useState({ page: 1, take: 10, totalData: 1 });

  const [datas, setDatas] = useState([]);
  const [selectedRow, setSelectedRow] = useState(null);
  const [deleteRow, setDeleteRow] = useState(null);

  async function getData() {
    try {
      setLoading(true);
      const res = await province.list(query);

      if (res.ok) {
        const body = await res.json();
        let data = body.data;
        setDatas(data.results);
        if (data.totalData) {
          setQuery((prev) => ({
            ...prev,
            totalData: data.totalData,
          }));
        }
      }
      setLoading(false);
    } catch (e) {
      toast.error(e.message);
      console.error(e);
    }
  }

  useEffect(() => {
    getData();
  }, [query.page, query.take]);

  function addData() {
    setOpenDetail(true);
  }

  function editData(value) {
    setSelectedRow(value);
    setOpenDetail(true);
  }

  function showConfirmationDlg(row) {
    setDeleteRow(row);
    setConfirmDlg(true);
  }

  async function deleteData() {
    try {
      const res = await province.delete(deleteRow.id);

      if (res.ok) {
        toast.success("This data has been deleted");
        setConfirmDlg(false);
        setDeleteRow(null);
        await getData();
      }
    } catch (e) {
      toast.error(e.message);
      console.error(e);
    }
  }

  const columns = [
    {
      name: "Name",
      selector: (row) => row.name,
    },
    {
      name: "Action",
      width: "150px",
      style: {
        paddingRight: "0",
      },
      cell: (row) => {
        return (
          <div>
            <PermissionChecker permissions={["edit category"]} hideIfNotAllowed>
              <button
                onClick={() => {
                  editData(row);
                }}
                className="btn btn-sm btn-outline-theme mx-1"
              >
                <i className="fa fa-edit"></i>
              </button>
            </PermissionChecker>
            <PermissionChecker
              permissions={["delete category"]}
              hideIfNotAllowed
            >
              <button
                onClick={() => {
                  showConfirmationDlg(row);
                }}
                className="btn btn-sm btn-outline-danger"
              >
                <i className="fa fa-trash"></i>
              </button>
            </PermissionChecker>
          </div>
        );
      },
    },
  ];

  async function onSubmit({ name }) {
    let data = {
      name: name.trim(),
    };

    if (!data.name) {
      toast.error("Please input a valid name!");
      return;
    }

    if (!selectedRow) {
      const response = await province.create(data);

      if (response.ok) {
        const body = await response.json();
        if (body.success) {
          toast.success(name + " is successfully added");
          setSelectedRow(null);
          setOpenDetail(false);
          await getData();
        } else {
          toast.error(body.message);
        }
      } else {
        toast.error("API Error");
      }
    } else {
      const response = await province.update(selectedRow.id, data);

      if (response.ok) {
        const body = await response.json();
        if (body.success) {
          toast.success("Successfully updated data");
          setSelectedRow(null);
          setOpenDetail(false);
          await getData();
        } else {
          toast.error(body.message);
        }
      } else {
        toast.error("API Error");
      }
    }
  }

  return (
    <div>
      <div className="d-flex align-items-center mb-3">
        <div>
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <a href="#/">Setup</a>
            </li>
            <li className="breadcrumb-item active">Province</li>
          </ol>
          <h1 className="page-header mb-0">Province</h1>
        </div>
      </div>

      <ModalChangeProvince
        onSubmit={onSubmit}
        open={openDetail}
        row={selectedRow}
        onClose={() => {
          setSelectedRow(null);
          setOpenDetail(false);
        }}
      />
      <ConfirmationDlg
        open={confirmDlg}
        onClose={() => {
          setConfirmDlg(false);
          setDeleteRow(null);
        }}
        onSubmit={deleteData}
      >
        <div>Are you sure you want to delete this?</div>
      </ConfirmationDlg>

      <div className="row gx-4">
        <div className="col-lg-12">
          <div className="row justify-content-end">
            <div className="col-sm-3 mb-2 mb-sm-0">
              <PermissionChecker
                permissions={["create category"]}
                hideIfNotAllowed
              >
                <button
                  onClick={addData}
                  className="btn btn-outline-theme w-100"
                >
                  Add Province <i className="bi bi-plus"></i>
                </button>
              </PermissionChecker>
            </div>
          </div>
          <Card className="mb-4 mt-2">
            <CardHeader>Province List</CardHeader>
            <CardBody>
              <DataTable
                progressPending={loading}
                highlightOnHover
                theme="dark"
                columns={columns}
                data={datas}
                pagination
                paginationServer
                onChangeRowsPerPage={(row) =>
                  setQuery((prev) => ({ ...prev, page: 1, take: row }))
                }
                paginationTotalRows={query.totalData}
                onChangePage={(page) =>
                  setQuery((prev) => ({ ...prev, page: page }))
                }
              />
            </CardBody>
          </Card>
        </div>
      </div>
    </div>
  );
}

export default ProvinceConfiguration;
